import { createSelector } from 'reselect';

export const selectEnvironmentSetting = (state) => state.EnvironmentSetting;
export const selectIsOpen = createSelector(
  selectEnvironmentSetting,
  (environmentSetting) => environmentSetting.isOpen,
);
export const selectCustomUrl = createSelector(
  selectEnvironmentSetting,
  (environmentSetting) => environmentSetting.customUrl,
);
export const selectUserName = createSelector(
  selectEnvironmentSetting,
  (environmentSetting) => environmentSetting.username,
);
export const selectPassword = createSelector(
  selectEnvironmentSetting,
  (environmentSetting) => environmentSetting.password,
);
export const selectContentGroup = createSelector(
  selectEnvironmentSetting,
  (environmentSetting) => environmentSetting.contentGroup,
);
